import { createSlice } from '@reduxjs/toolkit';

type ServiceTypesState = {
  createdCount: number;
};

const initialState: ServiceTypesState = {
  createdCount: 0,
};

export const serviceTypesSlice = createSlice({
  name: 'service-types',
  initialState,
  reducers: {
    incrementCreated: (state, action: { payload?: number }) => {
      state.createdCount += action.payload ?? 1;
    },
    resetCreated: (state) => {
      state.createdCount = 0;
    },
  },
});

export const { incrementCreated, resetCreated } = serviceTypesSlice.actions;
export default serviceTypesSlice.reducer;
